import {
  PatchExperienceAnalysisRequestBodyType,
  PatchExperienceAnalysisResponseBodyType,
} from "@intelligems/ig-types";
import { useMutation, useQueryClient } from "@tanstack/react-query";

import { api } from "../api";

const patchExperienceAnalysis = async (
  data: PatchExperienceAnalysisRequestBodyType,
  experienceId: string
): Promise<PatchExperienceAnalysisResponseBodyType> => {
  const resp = await api.patch<PatchExperienceAnalysisResponseBodyType>(
    `/v2/experience-analysis/${experienceId}`,
    data
  );
  return resp.data;
};

export const usePatchExperienceAnalysis = (experienceId?: string) => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationKey: ["mutatePatchExperienceAnalysis"],
    mutationFn: async (data: PatchExperienceAnalysisRequestBodyType) =>
      experienceId && patchExperienceAnalysis(data, experienceId),
    // onSuccess: async (data) => {
    //   if (experienceId) {
    //     queryClient.setQueryData(experienceKeys.one(experienceId), {
    //       experience: data.experience,
    //     });
    //   }
    // },
  });
};
